import React, { useEffect, useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { ChatItemHeader } from "../../../../pages/app/chat/ChatPartials";
import { chatData } from "../../../../pages/app/chat/ChatData";
import { Link } from "react-router-dom";
import { RootState } from "../../../../store/store";
import { useSelector, useDispatch } from "react-redux";
import { clearNotification } from "../../../../store/slices/misc/notificationSlice";
import miscService from "../../../../api/misc/misc";
import { Flex, Spin, Tooltip } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

const ChatDropdown = () => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggle = () => {
    setOpen(!open);
    if (!open && hasNewNotification) {
      dispatch(clearNotification());
    }
  };
  const hasNewNotification = useSelector(
    (state) => state.notification.hasNewNotification
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      fetchNotifications();
    }
  }, [open]);

  const fetchNotifications = async () => {
    setLoading(true);
    setError(null);
    let paramData = {
      sortOrder: "DESC",
      direction: "P",
      pageSize: 5,
      pageDiff: 0,
      viewed: 0,
    };
    try {
      const { response, status } = await miscService.notificationsList(
        paramData
      );
      if (status) {
        console.log("response", response.list);
        setNotifications(response.list);
      }
    } catch (err) {
      setError("Failed to load notifications.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dropdown isOpen={open} toggle={toggle}>
      <DropdownToggle
        tag="div"
        style={{ display: "inline-block" }}
      >
        <Tooltip title="Notifications" placement="bottom">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={(ev) => {
              ev.preventDefault();
              toggle();
            }}
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              background: open
                ? "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)"
                : "#f1f5f9",
              transition: "all 0.3s ease",
              boxShadow: open
                ? "0 4px 12px rgba(37, 99, 235, 0.3)"
                : "0 2px 4px rgba(0,0,0,0.05)",
              position: "relative",
            }}
            className={hasNewNotification ? "vibrating" : ""}
          >
            <BellOutlined
              style={{
                fontSize: "20px",
                color: open ? "#ffffff" : "#475569",
                transition: "color 0.3s ease",
              }}
            />
            {hasNewNotification && (
              <motion.span
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                style={{
                  position: "absolute",
                  top: "6px",
                  right: "6px",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                  border: "2px solid white",
                  boxShadow: "0 2px 4px rgba(239, 68, 68, 0.4)",
                }}
              />
            )}
          </motion.div>
        </Tooltip>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-xl">
        <div className="dropdown-head" onClick={() => toggle()}>
          <span className="sub-title nk-dropdown-title">Notifications</span>
          {/* <Link to={`${process.env.PUBLIC_URL}/user-profile-setting`}>Setting</Link> */}
        </div>
        <div className="dropdown-body">
          {loading ? (
            <Flex
              align="center"
              gap="middle"
              style={{ height: "360px", margin: "auto" }}
            >
              <Spin size="large" className="m-auto" />
            </Flex>
          ) : error ? (
            <div className="text-center text-danger">{error}</div>
          ) : notifications && notifications.length > 0 ? (
            <ul className="chat-list">
              {notifications?.map((item, i) => {
                return (
                  <ChatItemHeader
                    key={item.notificationId}
                    item={item}
                    toggle={toggle}
                  />
                );
              })}
            </ul>
          ) : (
            <div className="text-center">No notifications available.</div>
          )}
        </div>
        <div className="dropdown-foot center" onClick={() => toggle()}>
          <Link to={`${process.env.PUBLIC_URL}/notifications`}>View All</Link>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ChatDropdown;
